import { Injectable } from "@angular/core";
import { API_METHODS, API_URL } from "common/constants/sm-constants";
import { SystemService } from "../../../core-services/system.service";
import { FormDataService } from "../../base-data-services/form-data.service";
import { SmApiService } from "../../../core-services/sm-api.service";
import { environment } from "src/environments/environment";
import { editInfo } from "common/models/utility-models/utility-interface";
import { LocationModel } from "common/models/page-models/Location/location-data-model";





@Injectable({
    providedIn: 'root'
})
export class LocationFormDataService extends FormDataService<LocationModel> {
   
    constructor(http: SmApiService, protected override ss: SystemService) {
        super(API_URL.locationAdd, http, ss);
    }
    override getEditUrlAndMethod(id) {
        const edit = {
            url: environment.apiUrl + API_URL.location_edit,
            method: API_METHODS.post
        }
        return edit;
    }

    override getUpdatePayload(data){        
        const payload = {
            id: data.id
        }
        return payload;
    }

    // override modifyAPIResponse(response: any) {
         
    //     return response['details'];
    // }

  

 
    override getUpdateUrl() {
        return API_URL.update_location;
    }

    createInstance(): LocationModel {
        
        return new LocationModel();

    }

}

export { FormDataService };
